import React from "react";
import parseTextFromJson from "../utils/parseOldArticle";
import {AdfoxSticky} from "../components/adfoxBlocks/AdfoxSticky"

function calculateChunksCount(chunksLength) {
    const configArray = [
        { chunkLength: 3, config: { adfoxNum: 1, paragraphNum: 1 } },
        { chunkLength: 6, config: { adfoxNum: 1, paragraphNum: 2 } },
        { chunkLength: 8, config: { adfoxNum: 2, paragraphNum: 3 } },
        { chunkLength: 12, config: { adfoxNum: 2, paragraphNum: 4 } },
        { chunkLength: 16, config: { adfoxNum: 3, paragraphNum: 4 } },
        { chunkLength: 20, config: { adfoxNum: 4, paragraphNum: 4 } },
    ];
    if (chunksLength >= 20) {
        return { adfoxNum: 4, paragraphNum: 5 };
    }
    if (chunksLength < 3) {
        return { adfoxNum: 0, paragraphNum: 0 };
    }
    for (const item of configArray) {
        if (chunksLength < item.chunkLength) {
            return item.config;
        }
    }
}

function split(news) {
    let el = document.createElement("div");
    if (news.content[0] === '{') {
        el.innerHTML = parseTextFromJson(news.content);
    } else {
        el.innerHTML = news.content;
    }
    const chunks = Array.from(el.children).map(el => el.innerHTML);
    const config = calculateChunksCount(chunks.length);
    for (let i = 1; i < config.adfoxNum + 1; i++) {
        chunks.splice(config.paragraphNum * i, 0, "ADFOX");
    }
    return chunks;
}

function getAdfoxComponents(isFull, isDesktop, options) {
    return {
        1: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir2}/>,
        2: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir3}/>,
        3: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir4}/>,
        4: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir5}/>,
    };
}

function NewsText({ news, isFull, isDesktop, options }) {
    const contentRef = React.useRef(null);
    const url = new URL(window.location.href);
    const chunks = split(news);
    const adfoxNum = calculateChunksCount(chunks.length)["adfoxNum"];
    const selectedComponentsMap = getAdfoxComponents(isFull, isDesktop, options);
    let cnt = 1;

    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    }
    else {
        fullNewsUrl.searchParams.set('view', 'full');
    }

    return (
        <div className="newsDetail">
            <div className={!isFull ? "news-content-inner__toggle" : null} ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum && isFull) {
                        cnt += 1;
                        return <React.Fragment key={cnt - 1}>{selectedComponentsMap[cnt - 1]}</React.Fragment>;
                    }
                    if (i === chunks.length - 1) {
                        cnt = 1;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={!isFull && chunk === "ADFOX"} dangerouslySetInnerHTML={{ __html: chunk }} />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className={!isFull ? "toggleNews" : "hidden"}>
                <div className={!isFull ? "fadeNews" : null}></div>
                <a className={!isFull ? "openButton" : "hidden"} href={fullNewsUrl.toString()} target="_blank">Показать больше</a>
            </div>
        </div>
    );
}

NewsText.defaultProps = {
    teasers: [],
};

export default NewsText;
